import React, { FC } from 'react';
import {
  ViewerContainer,
  GridContainer,
  GridItemImage,
  GridItemText,
  ImageElement,
  Text,
} from 'pages/DocumentBuilder/components/HeaderSection/HeaderSection.styled';
import { FooterElement } from 'features/document/constants';
import { useGetFileQuery } from 'features/files/filesApi';

interface ViewerFooterSectionProps {
  footer: FooterElement;
  isIndividualFooterVisible: boolean;
  pageNumber: number;
  totalPages: number;
}

const ViewerFooterSection: FC<ViewerFooterSectionProps> = ({
  footer,
  isIndividualFooterVisible,
  pageNumber,
  totalPages,
}) => {
  const { content, style } = footer;
  const { data: backgroundImageData } = useGetFileQuery(Number(footer.content.backgroundImage.id), {
    skip: footer.content.backgroundImage.id === null,
  });

  const { data: logoData } = useGetFileQuery(Number(footer.content.logo.id), {
    skip: footer.content.logo.id === null,
  });
  return (
    <ViewerContainer
      aria-hidden='true'
      backgroundColor={content.hasBackgroundColor && isIndividualFooterVisible ? style.backgroundColor : ''}
      backgroundImage={content.hasBackgroundImage && content.backgroundImage.id ? backgroundImageData?.data.url : ''}
      isVisible={isIndividualFooterVisible}
      backgrounImageOpacity={style.backgroundImageOpacity}
      backgroundCover={style.backgroundCover}
      backgroundPosition={style.backgroundPosition}
    >
      {isIndividualFooterVisible && (
        <GridContainer container justifyContent='space-between' alignItems='center'>
          <GridItemImage item xs={4} display='flex'>
            {content.hasLogo && content.logo.id && <ImageElement src={logoData?.data.url} alt='logo' />}
          </GridItemImage>
          <GridItemText item xs={6}>
            <Text fontSize={style.labelFontSize} labelFont={style.labelFont} fontColor={style.fontColor}>
              {content.hasPageNumbering && `${pageNumber} of ${totalPages}`}
            </Text>
          </GridItemText>
        </GridContainer>
      )}
    </ViewerContainer>
  );
};

export default ViewerFooterSection;
